import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { FavoriteToggle } from '~src/favorites/components/favoriteToggle/FavoriteToggle';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard, getContentUrlForItem } from '~src/spacesPlatform/components/card/ContentCard';
import { Thumbnail } from '~src/spacesPlatform/components/card/Thumbnail';

import { PublishedConnectionTooltip } from '../../../publishedConnection/components/tooltips/PublishedConnectionTooltip';

export const PublishedConnectionTableDefaultImageUrl = imgPath('spaces_masthead_table_connection.svg');

export class PublishedConnectionTableCard extends ContentCard {
  public render() {
    const {
      content, hovered, selected, allowDragAndDrop, urls, addContentFavorite, removeContentFavorite
    } = this.props;
    return (
      <div className={CardViewStyles.Card}>
        <Thumbnail
          defaultImageUrl={PublishedConnectionTableDefaultImageUrl}
          thumbnailImageUrl={content.thumbnailUrl}
          hovered={hovered}
          selected={selected}
          navigateUrl={getContentUrlForItem(content, urls)}
          useBase64EncodedImage={true}
          allowDragAndDrop={allowDragAndDrop}
          aria-label={content.name}
        />
        <div className={CardViewStyles.ActionRow}>
          <span className={CardViewStyles.ActionRowName} title={content.name}>
            {content.name}
          </span>
          <span>
            <CardPopoverWidget
              content={content}
              onTriggerClick={this.handleShowPopover}
              popoverContent={this.renderPopoverContent()}
              title={Messages.publishedConnectionTableTooltipTitle()}
            />
          </span>
          <span>
            <FavoriteToggle
              isTabbable={true}
              isFavorite={content.favorite}
              onAddFavorite={() => addContentFavorite({ ...content, contentType: 'virtualConnectionTable' })}
              onRemoveFavorite={() => removeContentFavorite({ ...content, contentType: 'virtualConnectionTable' })}
            />
          </span>
          {this.renderActionsMenu()}
        </div>
        <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>
      </div>
    );
  }

  private renderPopoverContent = () => <PublishedConnectionTooltip
    content={this.props.content}
    urls={this.props.urls}
    inProjectSpace={this.props.inProjectSpace}
  />;
}
